import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ContactService } from 'app/core/contact/contact.service';
import { InitialData } from './contact-detail.types';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class ContactDetailDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _contactService: ContactService, 
        private _router:Router, private _toaster:ToastrService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<InitialData> {
        return this._contactService.getContactDetails(route.params['id'])
            .pipe(
                map((contact) => ({
                    contact
                })
                ),
                catchError(err => {
                    this._toaster.error("Couldn't find the specified contact")
                    this._router.navigate(['/']);
                    this._contactService.errorMessage = err.error.message ? err.error.message : "Something went wrong !";
                    return of(new DefaultResponse().contact);
                })
            );
    }

}
class DefaultResponse implements InitialData {
    contact: any = {};
}